document.addEventListener('DOMContentLoaded', function () {
  const componentFormModals = document.querySelectorAll('[data-form-modal]');

  if (componentFormModals.length === 0) return;

  function closeComponentFormModal(componentFormModal) {
    componentFormModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-form-modal-open');
  }

  function openComponentFormModal(componentFormModal) {
    componentFormModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-form-modal-open');
  }

  function setupComponentFormModal(componentFormModal) {
    const componentFormModalCloseButtons = componentFormModal.querySelectorAll('[data-form-modal-close]');

    componentFormModalCloseButtons.forEach((componentFormModalCloseButton) => {
      componentFormModalCloseButton.addEventListener('click', function () {
        closeComponentFormModal(componentFormModal);
      });
    });
  }

  function setupComponentFormModalTrigger(componentFormModalTrigger) {
    componentFormModalTrigger.addEventListener('click', function (event) {
      const componentFormModalId = getComponentFormModalTriggerId(componentFormModalTrigger);
      const componentFormModal = document.querySelector(`[data-form-modal="${componentFormModalId}"]`);

      if (!componentFormModal) return;

      event.preventDefault();
      openComponentFormModal(componentFormModal);
    });
  }

  function getComponentFormModalTriggerId(componentFormModalTrigger) {
    const componentFormModalTriggerId = componentFormModalTrigger.getAttribute('data-form-modal-open');

    if (componentFormModalTriggerId) {
      return componentFormModalTriggerId;
    }

    const componentFormModalTriggerHref = componentFormModalTrigger.getAttribute('href') || '';

    if (componentFormModalTriggerHref.charAt(0) !== '#') {
      return '';
    }

    return componentFormModalTriggerHref.slice(1);
  }

  componentFormModals.forEach(setupComponentFormModal);
  document.querySelectorAll('[data-form-modal-open], a[href^="#"]').forEach(setupComponentFormModalTrigger);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    componentFormModals.forEach((componentFormModal) => {
      if (componentFormModal.getAttribute('aria-hidden') === 'false') {
        closeComponentFormModal(componentFormModal);
      }
    });
  });
});
